document.addEventListener('DOMContentLoaded', initPeptidesPage);

function initPeptidesPage() {
  const page = document.querySelector('[data-peptides-page]');
  if (!page) return;

  const grid = page.querySelector('[data-peptides-grid]');
  const detail = page.querySelector('[data-peptides-detail]');
  const empty = page.querySelector('[data-peptides-empty]');
  const productsEl = page.querySelector('[data-peptides-products]');
  const config = window.PeptidesPageConfig || {};

  let products = {};
  try {
    products = JSON.parse(productsEl?.textContent || '{}');
  } catch (e) {
    products = {};
  }

  let activeId = null;

  fetch(config.dataUrl)
    .then((res) => res.json())
    .then((peptides) => {
      renderGrid(peptides);
    })
    .catch(() => {
      if (grid) {
        grid.innerHTML = '<p class="peptides-page__error">Unable to load peptide data.</p>';
      }
    });

  function resolveProduct(peptide) {
    const handles = [peptide.productHandle, peptide.id, peptide.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')].filter(Boolean);
    for (const handle of handles) {
      if (products[handle]) return products[handle];
    }
    return null;
  }

  function resolveImage(peptide) {
    const product = resolveProduct(peptide);
    if (product?.image) return product.image;
    return null;
  }

  function renderGrid(peptides) {
    if (!grid) return;
    grid.innerHTML = peptides
      .map(
        (peptide, index) => `
      <button
        type="button"
        class="peptides-page__card"
        data-peptide-id="${escapeAttr(peptide.id)}"
        data-testid="button-peptide-${escapeAttr(peptide.id)}"
        style="animation-delay: ${index * 0.05}s"
      >
        <div class="peptides-page__card-media">
          ${
            resolveImage(peptide)
              ? `<img src="${escapeAttr(resolveImage(peptide))}" alt="${escapeAttr(peptide.name)}" class="peptides-page__card-image" loading="lazy">`
              : `<span class="peptides-page__card-placeholder" aria-hidden="true"></span>`
          }
        </div>
        <h3 class="peptides-page__card-title">${escapeHtml(peptide.name)}</h3>
        <span class="peptides-page__card-category">${escapeHtml(peptide.category)}</span>
      </button>`
      )
      .join('');

    grid.querySelectorAll('[data-peptide-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.peptideId;
        const peptide = peptides.find((p) => p.id === id);
        if (!peptide) return;

        if (activeId === id) {
          activeId = null;
          hideDetail();
          return;
        }

        activeId = id;
        grid.querySelectorAll('.peptides-page__card').forEach((el) => {
          el.classList.toggle('is-active', el.dataset.peptideId === id);
        });
        showDetail(peptide);
      });
    });
  }

  function showDetail(peptide) {
    if (!detail || !empty) return;

    const product = resolveProduct(peptide);
    const image = resolveImage(peptide);

    detail.innerHTML = `
      <div class="peptides-page__detail-bg cosmic-bg" aria-hidden="true"></div>
      <div class="peptides-page__detail-inner">
        <div class="peptides-page__detail-header">
          <div class="peptides-page__detail-heading">
            <div class="peptides-page__detail-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"/><path d="M8.5 2h7"/><path d="M7 16h10"/></svg>
            </div>
            <div>
              <h2 class="peptides-page__detail-title" data-testid="text-detail-name">${escapeHtml(peptide.name)}</h2>
              <p class="peptides-page__detail-subtitle">${escapeHtml(peptide.fullName)}</p>
            </div>
          </div>
          <button type="button" class="peptides-page__detail-close" data-peptide-close aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </button>
        </div>

        <div class="peptides-page__detail-grid">
          <div class="peptides-page__detail-sidebar">
            <div class="peptides-page__detail-image-wrap">
              ${
                image
                  ? `<img src="${escapeAttr(image)}" alt="${escapeAttr(peptide.name)}" class="peptides-page__detail-image" data-testid="img-detail-product">`
                  : `<div class="peptides-page__detail-image-placeholder"></div>`
              }
            </div>
            <dl class="peptides-page__meta">
              <div class="peptides-page__meta-row">
                <dt>Sequence</dt>
                <dd>${escapeHtml(peptide.sequence)}</dd>
              </div>
              <div class="peptides-page__meta-row">
                <dt>Mol. Weight</dt>
                <dd>${escapeHtml(peptide.molecularWeight)}</dd>
              </div>
              <div class="peptides-page__meta-row">
                <dt>Category</dt>
                <dd class="peptides-page__meta-category">${escapeHtml(peptide.category)}</dd>
              </div>
              <div class="peptides-page__meta-row">
                <dt>Purity</dt>
                <dd>≥99% (HPLC)</dd>
              </div>
            </dl>
          </div>

          <div class="peptides-page__detail-content">
            <section class="peptides-page__detail-block">
              <h3><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg> Overview</h3>
              <p data-testid="text-detail-summary">${escapeHtml(peptide.summary)}</p>
            </section>

            <section class="peptides-page__detail-block">
              <h3><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg> Research Applications</h3>
              <ul class="peptides-page__areas">
                ${(peptide.researchAreas || [])
                  .map((area) => `<li><span class="peptides-page__areas-dot" aria-hidden="true"></span>${escapeHtml(area)}</li>`)
                  .join('')}
              </ul>
            </section>

            <section class="peptides-page__detail-block">
              <h3><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4"/><path d="m6.8 15-3.5 2"/><path d="m20.7 17-3.5-2"/><path d="M6.8 9 3.3 7"/><path d="m20.7 7-3.5 2"/><circle cx="12" cy="12" r="4"/></svg> Mechanism of Action</h3>
              <p data-testid="text-detail-mechanism">${escapeHtml(peptide.mechanism)}</p>
            </section>

            <section class="peptides-page__detail-block">
              <h3><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4.5 3h15"/><path d="M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3"/><path d="M6 14h12"/></svg> Key Findings</h3>
              <p data-testid="text-detail-findings">${escapeHtml(peptide.keyFindings)}</p>
            </section>

            ${
              product?.url
                ? `<a href="${escapeAttr(product.url)}" class="peptides-page__product-link" data-testid="link-view-product">View Product<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>`
                : ''
            }
          </div>
        </div>
      </div>
    `;

    detail.hidden = false;
    empty.hidden = true;

    detail.querySelector('[data-peptide-close]')?.addEventListener('click', () => {
      activeId = null;
      grid.querySelectorAll('.peptides-page__card').forEach((el) => el.classList.remove('is-active'));
      hideDetail();
    });

    detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideDetail() {
    if (!detail || !empty) return;
    detail.hidden = true;
    detail.innerHTML = '';
    empty.hidden = false;
    grid?.querySelectorAll('.peptides-page__card').forEach((el) => el.classList.remove('is-active'));
  }
}

function escapeHtml(str) {
  return String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeAttr(str) {
  return escapeHtml(str).replace(/'/g, '&#39;');
}
